import { useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FolderOpen, Zap, Sparkles, Clock } from 'lucide-react';

gsap.registerPlugin(ScrollTrigger);

const stats = [
  { icon: FolderOpen, value: '10K+', label: 'Assets organized', color: '#2EC4B6' },
  { icon: Zap, value: '50%', label: 'Faster flyer creation', color: '#FF6B4A' },
  { icon: Sparkles, value: '1-Click', label: 'AI generation', color: '#2EC4B6' },
  { icon: Clock, value: '30min', label: 'Saved per flyer', color: '#FF6B4A' },
];

export default function StatsStrip({ className = '' }: { className?: string }) {
  const sectionRef = useRef<HTMLElement>(null);
  const itemsRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        itemsRef.current?.children || [],
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.08,
          ease: 'power2.out',
          scrollTrigger: { trigger: section, start: 'top 85%', toggleActions: 'play none none reverse' },
        }
      );
    }, section);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className={`py-8 border-y border-white/10 bg-[#0d1214]/80 ${className}`}>
      <div className="w-full px-6 lg:px-12">
        <div ref={itemsRef} className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex items-center gap-4 text-center md:text-left"
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto md:mx-0"
                style={{ backgroundColor: `${stat.color}15` }}
              >
                <stat.icon size={22} style={{ color: stat.color }} />
              </div>
              <div>
                <div className="font-display font-bold text-xl text-white">{stat.value}</div>
                <div className="text-sm text-[#A9B4B8]">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
